module.exports = __webpack_public_path__ + "static/media/endorse_wdg.9275396f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/botrytis_pimiento/curativa/endorse_wdg.png
// module id = 2200
// module chunks = 3